export default "__VITE_ASSET__e570682b__"